import React from 'react';
import './FixedContact.css';

export default function FixedContact() {
    return (
        <div className="fixed-contact-bar">
            {/* Call Button */}
            <a href="tel:+919842943377" className="contact-icon call" title="Call Us">
                <i className="fas fa-phone-alt"></i>
            </a>

            {/* WhatsApp Button */}
            <a href="https://wa.me/919842943377" target="_blank" rel="noreferrer" className="contact-icon whatsapp" title="WhatsApp">
                <i className="fab fa-whatsapp"></i>
            </a>

            {/* Email Button */}
            <a href="mailto:varkbuilders2026@gmail.com" className="contact-icon email" title="Email Us">
                <i className="fas fa-envelope"></i>
            </a>

            {/* Instagram Button */}
            <a href="https://www.instagram.com/vark_builders_private_limited/" target="_blank" rel="noreferrer" className="contact-icon instagram" title="Instagram">
                <i className="fab fa-instagram"></i>
            </a>

            {/* Facebook Button */}
            <a href="https://facebook.com/varkbuilders" target="_blank" rel="noreferrer" className="contact-icon facebook" title="Facebook">
                <i className="fab fa-facebook-f"></i>
            </a>
        </div>
    );
}